
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 13 21.688\" id=\"icon-lock\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M7.236,15.264v2.141c0,0.48-0.39,0.873-0.873,0.873c-0.482,0-0.873-0.393-0.873-0.873v-2.141\r\n\tc-0.763-0.337-1.296-1.098-1.296-1.984c0-1.198,0.971-2.17,2.168-2.17c1.198,0,2.168,0.972,2.168,2.17\r\n\tC8.532,14.166,8,14.927,7.236,15.264 M5.205,6.631V4.604c0-0.641,0.519-1.165,1.159-1.165c0.64,0,1.16,0.523,1.16,1.165v3.931H0.571\r\n\tC0.256,8.534,0,8.81,0,9.124v7.96c0,1.167,0.854,4.604,6.364,4.604c5.51,0,6.636-3.489,6.636-4.604V4.604C13,3.515,11.874,0,6.364,0\r\n\tC0.854,0,0,3.515,0,4.604v2.028 M0,6.636C0,6.95,0.256,7.213,0.571,7.213h4.063c0.315,0,0.571-0.263,0.571-0.577\"/> </symbol>";
module.exports = sprite.add(image, "icon-lock");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/lock.svg
 ** module id = 197
 ** module chunks = 24
 **/